<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">

					</div>
					<div class="card-body overflow-auto">
						{{campaign}}
						<div class="form-group">
									<label>Category</label>
									<select class="form-control" v-model="category">
										<option v-for="i in categories" value="i.name">{{i.name}}</option>
									</select>
								</div>
								<div class="form-group">
									<label>Product</label>
									<select class="form-control" v-model="product">
										<option v-for="i in products" value="i.product_name">{{i.product_name}}</option>
									</select>
								</div>
								<div class="form-group">
									<label>Division</label>
									<select class="form-control" v-model="division">
										<option v-for="i in divisions" value="i.name">{{i.name}}</option>
									</select>
								</div>
								<div class="form-group">
									<label>From Date</label>
									<input type="date" class="form-control" placeholder="Enter the from date" v-model="from">
								</div>
								<div class="form-group">
									<label>To Date</label>
									<input type="date" class="form-control" placeholder="Enter the to date" v-model="to">
								</div>
								<div class="form-group">
									<label>Phone</label>
									<input type="number" class="form-control" placeholder="Enter the phone number" v-model="phone" min="0">
								</div>
								<div class="form-group">
									<label>Item Code</label>
									<input type="text" class="form-control" placeholder="Enter the item code" v-model="itemcode" min="0">
								</div>
								<button class="btn btn-primary" @click="getRegistrations('/api/getGiftCampaignRegistrations')">Search</button>
								<button class="btn btn-primary" @click="reset">Reset</button>
								<table class="table table-hover table-striped table-bordered">
									<thead>
										<tr>
											<th scope="col">Category</th>
											<th scope="col">Product</th>
											<th scope="col">Division</th>
											<th scope="col">Item Code</th>
											<th scope="col">Name</th>
											<th scope="col">Phone</th>
											<th scope="col">Email</th>
											<th scope="col">Amount</th>
											<th scope="col">Manage</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="r in registrations">
											<td>{{r.category}}</td>
											<td>{{r.product}}</td>
											<td>{{r.division}}</td>
											<td>{{r.itemcode}}</td>
											<td>{{r.first_name}} {{r.last_name}}</td>
											<td>{{r.phone}}</td>
											<td>{{r.email}}</td>
											<td>{{r.amount}}</td>
											<td></td>
										</tr>
									</tbody>
									<tfoot>
										<pagination :pagination="pagination"
										 	@prev="getRegistrations(pagination.prevPageUrl)"
											@next="getRegistrations(pagination.nextPageUrl)"
										></pagination>
									</tfoot>
								</table>
					</div>
					<div class="card-footer">

					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
        	this.getCampaign();
        	this.getRegistrations();
        	this.getCategories();
        	this.getProducts();
        	this.getDivisions();
        },

        data(){
        	return {
        		campaign: {},
        		registrations: [],
        		categories: [],
        		products: [],
        		divisions: [],
        		errors: [],
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		product: null,
         		category: null,
         		division: null,
         		from: null,
         		to: null,
         		phone: null,
         		itemcode: null
        	}
        },

        methods: {
        	getCampaign(){
        		axios.post("/api/getGiftCampaign", {id: this.$route.params.id})
        		.then(response => {
        			this.campaign = response.data;
        		});
        	},

        	getRegistrations(url="/api/getGiftCampaignRegistrations"){
        		axios.post(url, {
        			campaign: this.$route.params.id,
        			product: this.product,
		       		category: this.category,
		       		division: this.division,
		       		from: this.from,
		       		to: this.to,
		       		phone: this.phone,
		       		itemcode: this.itemcode
        		})
        		.then(response => {
        			this.registrations = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

        	getCategories(){
        		axios.post("/api/getGiftCategories")
        		.then(response => {
        			this.categories = response.data;
        		});
        	},

        	getProducts(){
        		axios.post("/api/getMasterProductList")
        		.then(response => {
        			this.products = response.data;
        		});
        	},

        	getDivisions(){
        		axios.post("/api/getGiftSubCategories")
        		.then(response => {
        			this.divisions = response.data;
        		});
        	},

        	reset(){
        		this.product = null;
         		this.category = null;
         		this.division = null;
         		this.from = null;
         		this.to = null;
         		this.itemcode = null;
         		this.phone = null;
         		this.getRegistrations();
        	}
        }
    }
</script>
